<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/template/event/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mubanshiijandianbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')">
            <el-input v-model="yt.conditions.desc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({templateId:yt.conditions.templateId,orderBy:'code'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
				<!-- 左侧按钮插槽 -->
				<template #buttonsL>
					<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
						{{$t('xinzeng')}}
					</el-button>
				</template>
				<!-- 操作插槽 -->
				<template #caozuo="scope">
					<el-row :gutter="10">
						<el-col :span="0.1">
							<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
						</el-col>
						<el-col :span="0.1">
							<el-button type="text" class="font-color-danger"
								@click="yt.remove(scope.row,'/web/template/event/delete')">{{$t('shanchu')}}
							</el-button>
						</el-col>
					</el-row>
				</template>
		</yi_curd_table>
			<!-- 新增/编辑弹框 -->
			<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
				:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
				<!-- 新增表单 -->
				<template v-if="yt.editObj.action == 'xinzeng'">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('mubanshiijandianbianma')" required>
							<el-input v-model="yt.editObj.code"></el-input>
						</el-form-item>
						<el-form-item :label="$t('fanyi')" required>
							<el-input v-model="yt.editObj.i18n"></el-input>
						</el-form-item>
						<el-form-item :label="$t('miaoshu')">
							<el-input v-model="yt.editObj.desc"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/event/create',beforeAdd)"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
				<!-- 更新表单 -->
				<template v-if="yt.editObj.action == 'bianji'">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('mubanshiijandianbianma')" required>
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('fanyi')" required>
						<el-input v-model="yt.editObj.i18n"></el-input>
					</el-form-item>
					<el-form-item :label="$t('miaoshu')">
						<el-input v-model="yt.editObj.desc"></el-input>
					</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/event/update')"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
			</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		name: 'admin_data_equipment_template_event',
		data() {
			return {
				columns: [{
					label: 'mubanshiijandianbianma',
					prop: 'code',
				}, {
					label: 'fanyi',
					prop: 'i18n',
				}, {
					label: 'miaoshu',
					prop: 'desc',
				},{
					label: 'caozuo',
					type: 'slot',
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
          templateId: this.$attrs.templateId
				}
				this.yt.get(1);
        this.utils.event_hub.$on('EQUIPMENT_TEMPLATE_EVENT_REFRESH', () => {
          this.yt.get(1);
        })
			}, 300)		
		},
		methods: {
			// 字典值新增
			 beforeAdd(params, url) {
				 params.templateId = this.$attrs.templateId
			 	return params
			 },
		
		}
	};
</script>


<style>
</style>
